var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("section", [
    _c(
      "div",
      {
        staticClass: "container",
      },
      [
        _c(
          "div",
          {
            staticClass: "row justify-content-center",
          },
          [
            _c(
              "div",
              {
                staticClass: "col-6 col-sm-4 col-lg-2 mb-3",
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary w-100",
                    attrs: {
                      type: "button",
                    },
                    on: {
                      click: function ($event) {
                        _vm.soidown = !_vm.soidown
                      },
                    },
                  },
                  [_vm._v("\n          สอยดาว\n        ")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-6 col-sm-4 col-lg-2 mb-3",
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary w-100",
                    attrs: {
                      type: "button",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.filterFunction("yeekee_jetsada")
                      },
                    },
                  },
                  [_vm._v("\n          ยี่กี JETSADA\n        ")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-6 col-sm-4 col-lg-2 mb-3",
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary w-100",
                    attrs: {
                      type: "button",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.filterFunction("yeekee_huay")
                      },
                    },
                  },
                  [_vm._v("\n          ยีกี HUAY\n        ")]
                ),
              ]
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid",
      },
      _vm._l(_vm.results, function (result) {
        return _c(
          "div",
          {
            key: result.id,
            ref: "{{result.slug}}",
            refInFor: true,
            class: _vm.resultBoxClass,
            attrs: {
              "v-show": _vm.soidown,
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "col-12",
              },
              [_vm._v("\n        ผลรางวัล " + _vm._s(result.name) + "\n      ")]
            ),
            _vm._v(" "),
            _vm._l(result.latestGameWithResults, function (n) {
              return _c(
                "div",
                {
                  key: n.id,
                  staticClass: "col-12 mb-3 col-sm-3 col-md-2 col-lg-2",
                },
                [
                  _c("result-item", {
                    attrs: {
                      id: n.id,
                      "digit-under": `0`,
                      "digit-upper": `0`,
                      status: n.status,
                      "close-at": n.close_at,
                      title: result.name,
                      "round-read": result.readableEdition,
                    },
                  }),
                ],
                1
              )
            }),
          ],
          2
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "col-6 col-sm-4 col-lg-2 mb-3",
      },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-primary w-100",
            attrs: {
              type: "button",
            },
          },
          [_vm._v("\n          หวยหุ้น\n        ")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "col-6 col-sm-4 col-lg-2 mb-3",
      },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-primary w-100",
            attrs: {
              type: "button",
            },
          },
          [_vm._v("\n          หวยรัฐ\n        ")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }